import { NgModule } from "@angular/core";
import { AppRoutingModule } from 'app/app.routing';
import { CommonModule } from "@angular/common";
import { FormsModule } from '@angular/forms';
import { BrowserModule } from "@angular/platform-browser";
import { BsDropdownModule } from 'ngx-bootstrap';

import { HeadMenuComponent } from "app/components/head-menu/head-menu.component";
import { AuthService } from "app/services/auth/auth.service";
import { RedirectService } from "app/services/page/redirect.service";



@NgModule({
    imports: [
        AppRoutingModule,
        CommonModule,
        FormsModule,
        BrowserModule,
        BsDropdownModule.forRoot()
    ],
    declarations: [
        HeadMenuComponent
    ],
    providers: [AuthService, RedirectService],
    exports: [
        HeadMenuComponent
    ]
})
export class HeadMenuModule {}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/head-menu/head-menu.module.ts